import styled from "styled-components"

export default function OrderHsitoryItem({ children }) {
  return <Block>{children}</Block>
}

const Block = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 12px solid #f7f7f7;
  padding-left: calc(100vw * (17 / 375));
  padding-right: calc(100vw * (17 / 375));
  padding-top: calc(100vw * (23 / 375));

  &:nth-last-child(1) {
    border-bottom: none;
  }
`
